"use client"

import { MessageCircleReply } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MessageCircleReplyIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MessageCircleReplyIcon = component(Icon)({
  as: MessageCircleReply,
})
